/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const PrescriptionBottleAltIconConfig = {
  name: 'PrescriptionBottleAltIcon',
  height: 512,
  width: 384,
  svgPath: 'M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(PrescriptionBottleAltIconConfig);
//# sourceMappingURL=prescription-bottle-alt-icon.js.map